import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(4, 0),
    },
  },
  Suspense: {
    padding: theme.spacing(1.5),
    '& .MuiCardContent-root': {
      padding: theme.spacing(2),
    },
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
    minHeight: '389px',
  },
  Suspense1: {
    padding: theme.spacing(1.5),
    '& .MuiCardContent-root': {
      padding: theme.spacing(2),
    },
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
    minHeight: '389px',
    marginTop: 15,
  },
  rightWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
}));
